/**
 * Main page implementation.
 */

'use strict';

var app          = require('mag-app'),
    Page         = require('stb-component-page'),
    format       = require('cjs-format'),
    keys         = require('stb-keys'),
    // new way of using theme icons
    icons        = require('magcore-theme/icons'),
    Footer       = require('mag-component-footer'),
    List         = require('mag-component-list'),
    ExtendedList = require('../modules/list'),
    ModalMessage = require('mag-component-modal'),
    RadioList    = require('mag-component-radio-list'),
    LayoutList   = require('mag-component-layout-list'),
    ScrollBar    = require('stb-component-scrollbar'),
    page         = new Page({$node: window.pageMain, focusable: false}),
    // modules

    tools        = require('../modules/tools'),
    showExit     = require('../modules/app.exit')(page),

    LIST_ICONS   = require('../modules/list.icons'),
    // constants

    // every 15 minutes update epg for current channels
    CURRENT_EPG_UPDATE_DELAY = 1000 * 60 * 15,
    CHANNELS_UPDATE_NOTIFY_TIMEOUT = 7000,
    //
    tvConfig     = {
        favorite: false,
        byName: false,
        genre: false,
        genreName: gettext('All categories'),
        search: false
    },
    focusPanel   = {},
    osdTvIntent,
    playChannelTimeout,
    updateCurrentEpgInterval,
    updateListOfProgramsInterval,
    updateCurrentEpgTimeout,
    dataBuffer   = [],
    playAtAppStartFlag = false,
    epg = {
        list: [],
        currentIndex: 0
    },
    channelList, genresList, currentChannelIndex, ctx;

const {
    CORE_EVENT_SHOW,
    CORE_EVENT_HIDE,
    LEFT_ARROW_CLICK,
    RIGHT_ARROW_CLICK,
    PLAYER_SET_VIEWPORT,
    PLAYER_SET_FULLSCREEN,
    PLAYER_SEND_EXIT,
    CORE_EVENT_EXIT,
    CORE_EVENT_PLAY_CHANNEL
} = require('../modules/events');

// eslint-disable-next-line
const PLAY_BY_OK = app.config.playByOk;


/*eslint no-use-before-define:0*/
/*eslint max-lines:0*/

/**
 * Callback for osd-input intent.
 *
 * @param {number} value - value from user input
 */
function osdInputCallback ( value ) {
    var length = dataBuffer.length,
        showOsd = !core.applicationState.visible,
        index,
        channelIndex,
        channel;

    value = Number(value);

    for ( index = 0; index < length; index++ ) {
        if ( dataBuffer[index].number === value ) {
            channelIndex = index;
        }
    }

    if ( channelIndex === undefined ) {
        tools.notifyError(gettext('No such channel number'));
    } else {
        channel = dataBuffer[channelIndex];
        if ( channel.id === channelList.$focusItem.data.id ) {
            // do nothing, its active channel
            // maybe go to player if need
        } else {
            // here we need to check with 'else if' and remove eslint hack
            if ( app.ui.preview && !tools.isCensored(channel) ) { // eslint-disable-line
                channelList.focusIndex(channelIndex);
                playChannel(channelIndex, {showOsd: showOsd});
            } else if ( !app.ui.preview && !tools.isCensored(channel) ) {
                channelList.focusIndex(channelIndex);
                playChannel(channelIndex, {
                    fullscreen: true,
                    showOsd: showOsd
                });
            } else {
                core.accessControl.request(function ( error ) {
                    if ( !error ) {
                        channelList.$focusItem.data.unlocked = true;
                        app.ui.hideCensoredPlaceholder();
                        channel.unlocked = true;
                        if ( app.ui.preview ) {
                            channelList.focusIndex(channelIndex);
                            // clear because that focus will emit `select:item` event and channel will be blocked
                            clearTimeout(playChannelTimeout);
                            playChannel(channelIndex/*, {silent: true}*/);
                        } else {
                            playChannel(channelIndex, {fullscreen: true, showOsd: showOsd});
                        }
                    }
                });
            }
        }
    }
}


/**
 * Send play channel intent
 *
 * @param {number} index of channel to play
 * @param {Object} [config] to send intent
 */
function playChannel ( index, config ) {
    var channel = dataBuffer[index],
        vp,
        itemIndex,
        $listItem;

    config = config || {};

    if ( app.ui.preview && core.applicationState.visible ) {
        vp = app.metrics.canvasPosition;
    }

    if ( config.forceFullscreen ) {
        vp = false;
        config.silent = false;
    }

    if ( !channel ) { return; }

    function sendIntent ( url, solution ) {
        app.lastIntent = core.intent({
            action: 'play',
            mime: 'content/video',
            context: ctx,
            silent: config.silent,
            data: {
                uri: url,
                title: channel.name,
                tvChannel: channel,
                solution: solution,
                persistent: true,
                // do not show player panel at start
                headless: true,
                viewport: vp,
                // need to track content playback
                mediaId: channel.id,
                // extra channel data
                extra: channel.extra,
                retryOnError: true,
                stream: true,
                // disable pip for this app
                controls: {pip: false},
                volumeCorrection: channel['volume_correction']
            },
            events: {
                nextChannel: nextChannelHandler,
                prevChannel: prevChannelHandler,
                onInfoPress: function () {
                    osdTvIntent = tools.sendOsdTvIntent(channel, true);
                },
                close: function () {
                    ctx = null;
                    if ( osdTvIntent ) {
                        osdTvIntent.close();
                    }
                },
                onNumberPress: function ( event ) {
                    tools.sendOsdInputIntent(event.number, {
                        callback: osdInputCallback
                    });
                },
                start: function () {
                    tools.setChannelAsLast(channel);

                    // restore fullscreen playback if playback start after retrying
                    if ( !core.applicationState.visible  ) {
                        app.lastIntent.emit(PLAYER_SET_FULLSCREEN);
                    }
                },
                onPip: function () {
                    // process channel go to pip if need
                    ctx = null;
                    app.lastIntent = null;
                }
            }
        }, function ( error, context ) {
            if ( error ) {
                console.log(error);
            }
            ctx = context;
        });

        app.activeChannel = channel;
        currentChannelIndex = index;

        // last intent may be silent, cause core do not show player and we must call show
        if ( config.fullscreen ) {
            app.lastIntent.show(app.lastIntent.receiver);
        }
    }


    if ( channel.url ) {
        sendIntent(channel.url, channel.solution);
    } else {
        channel.getUrl(function ( error, data ) {
            if ( error ) {
                tools.notifyError(gettext('Error getting channel link'));
            } else {
                // data: {url, solution}
                sendIntent(data.url, data.solution);
            }
        });
    }

    if ( config.showOsd ) {
        osdTvIntent = tools.sendOsdTvIntent(channel);
    }

    for ( itemIndex = 0; itemIndex < app.pages.main.channelList.$body.children.length; itemIndex++ ) {
        $listItem = app.pages.main.channelList.$body.children[itemIndex];
        $listItem.$currentPlaybackIcon.classList.add('hide');

        if ( $listItem && $listItem.data && $listItem.data.id === channel.id ) {
            $listItem.$currentPlaybackIcon.classList.remove('hide');
        }
    }
}

function handleChannelClick ( event ) {
    var channel = event.$item.data;

    if ( tools.isCensored(channel) ) {
        // check parent control

        if ( app.activeChannel && app.activeChannel.id === channel.id ) {
            // play unblocked channel
            app.lastIntent.emit(PLAYER_SET_FULLSCREEN);
            app.lastIntent.show(app.lastIntent.receiver);
        } else {
            // core.accessControle
            core.accessControl.request(function ( error ) {
                if ( !error ) {
                    app.ui.hideCensoredPlaceholder();
                    // console.log(event.$item)
                    event.$item.data.unlocked = true;
                    if ( app.ui.preview ) {
                        playChannel(event.$item.index, {silent: true});
                    } else {
                        playChannel(event.$item.index, {fullscreen: true});
                    }
                }
            });
        }
    } else if ( app.ui.preview && app.lastIntent && app.activeChannel && channel.id === app.activeChannel.id ) {
        // send player command to turn viewport to fullscreen
        app.lastIntent.emit(PLAYER_SET_FULLSCREEN);
        // show player app
        app.lastIntent.show(app.lastIntent.receiver);
    } else if ( PLAY_BY_OK && app.ui.preview && app.lastIntent && app.activeChannel && channel.id !== app.activeChannel.id ) {
        playChannel(event.$item.index, {silent: true});
    } else {
        playChannel(channelList.$focusItem.index, {
            fullscreen: true
        });
    }
}

function nextChannelHandler () {
    var index = ++currentChannelIndex;

    if ( index > dataBuffer.length - 1 ) {
        index = 0;
        currentChannelIndex = 0;
    }


    if ( tools.isCensored(dataBuffer[index]) ) {
        nextChannelHandler();

        return;
    }

    playChannel(index);
    osdTvIntent = tools.sendOsdTvIntent(dataBuffer[index], false);
}

function prevChannelHandler () {
    var index = --currentChannelIndex;

    if ( index < 0 ) {
        index = currentChannelIndex = dataBuffer.length - 1;
    }

    if ( tools.isCensored(dataBuffer[index]) ) {
        prevChannelHandler();
    } else {
        playChannel(index);
        osdTvIntent = tools.sendOsdTvIntent(dataBuffer[index], false);
    }
}

/**
 * Send intent to play epg program
 *
 * @param {Object} epgObject to play
 * @param {number} channelIndex from list of current channels
 */
function sendPlayEpgIntent ( epgObject, channelIndex ) {
    var channel = dataBuffer[channelIndex];

    channel.getEpg(null, function ( error, data ) {
        var index,
            epgIndex;

        if ( !error && data && data.length ) {
            epg.list = data;

            for ( index = 0; index < data.length; index++ ) {
                if ( data[index].id === epgObject.id ) {
                    epgIndex = index;
                }
            }

            epg.currentIndex = epgIndex;

            if ( epgIndex ) {
                // data[epgIndex]
                data[epgIndex].getLink(function ( error, epgMeta ) {
                    var prevHandler,
                        nextHandler;

                    if ( !error && epgMeta && epgMeta.url ) {

                        // prev program handler
                        if ( epg.list[epg.currentIndex - 1] && epg.list[epg.currentIndex - 1].archive ) {
                            prevHandler = function () {
                                sendPlayEpgIntent(epg.list[--epg.currentIndex], channelIndex);
                            };
                        }

                        if ( epg.list[epg.currentIndex + 1] && epg.list[epg.currentIndex + 1].archive ) {
                            nextHandler = function () {
                                sendPlayEpgIntent(epg.list[++epg.currentIndex], channelIndex);
                            };
                        }

                        app.lastIntent = null;

                        core.intent({
                            action: 'play',
                            mime: 'content/video',
                            context: null,
                            data: {
                                uri: epgMeta.url,
                                solution: epgMeta.solution,
                                title: data[epgIndex].title,
                                mediaId: data[epgIndex].id,
                                resource: 'tv-archive',
                                controls: {pip: false}
                            },
                            events: {
                                close: function () {

                                    if ( osdTvIntent ) {
                                        osdTvIntent.close();
                                    }
                                    // add handler if need
                                    if ( app.ui.preview ) {
                                        // playChannel(channelIndex);
                                    }
                                },
                                next: nextHandler,
                                prev: prevHandler,
                                nextChannel: nextChannelHandler,
                                prevChannel: prevChannelHandler,
                                stop: function ( /*event*/ ) {
                                    playChannel(channelIndex, {fullscreen: true});
                                },
                                end: function () {
                                    if ( nextHandler ) {
                                        nextHandler();
                                    } else {
                                        this.close();
                                    }
                                }
                            }
                        }, function () { /**/ });

                    } else {
                        tools.notifyError(gettext('Error getting epg link'));
                    }
                });
            } else {
                tools.notifyError(gettext('Error getting epg link'));
            }
        } else {
            tools.notifyError(gettext('Error getting EPG for ') + channel.name);
        }

    });
}

app.sendPlayEpgIntent = sendPlayEpgIntent;

function updateCurrentChannelsEpg () {
    function update () {
        var channelsArray = [],
            length = channelList.$body.children.length,
            censoredState,
            index;

        for ( index = 0; index < length; index++ ) {
            if ( channelList.$body.children[index].data ) {
                channelsArray.push(channelList.$body.children[index].data);
            }
        }

        if ( channelsArray.length ) {
            app.tvBack.getChannelsEpg({channels: channelsArray}, function ( error, epgMap ) {
                var $item;

                if ( !error && epgMap ) {
                    for ( index = 0; index < length; index++ ) {
                        $item = channelList.$body.children[index];

                        // check for censored state to hide epg
                        censoredState = tools.isCensored($item.data);

                        if (
                            ( !censoredState || censoredState && core.accessControl.state ) &&
                            epgMap[$item.data.id] && epgMap[$item.data.id][0]
                        ) {
                            $item.$epg.innerText = epgMap[$item.data.id][0].title;
                            channelList.data[$item.index].currentEpg = epgMap[$item.data.id][0];
                        }
                    }
                    app.ui.updateFloatingPanel(channelList.$focusItem.data);
                }

            });
        }
    }


    clearTimeout(updateCurrentEpgTimeout);
    updateCurrentEpgTimeout = setTimeout(update, core.environment.onFocusDebounceTimeout || 400);

    clearInterval(updateCurrentEpgInterval);
    updateCurrentEpgInterval = setInterval(update, CURRENT_EPG_UPDATE_DELAY);
}

function togglePageView () {
    if ( !channelList.$focusItem ) {
        return;
    }
    app.ui.showPreview(!app.ui.preview);
    if ( app.ui.preview ) {
        // start playback
        if ( channelList.$focusItem && !tools.isCensored(dataBuffer[channelList.$focusItem.index]) ) {
            playChannel(channelList.$focusItem.index);
        } else {
            app.ui.showCensoredPlaceholder();
        }
    } else {
        clearTimeout(playChannelTimeout);
        app.ui.hideCensoredPlaceholder();
        app.ui.updateFloatingPanel(channelList.$focusItem.data, channelList.$focusItem.index - channelList.viewIndex);

        if ( app.lastIntent ) {
            app.lastIntent.emit(PLAYER_SEND_EXIT);
            app.activeChannel = null;
        }
    }
}

/**
 * Navigate to TV guide page
 */
function goToEpgPage () {
    if ( tools.isCensored(channelList.$focusItem.data) && !core.accessControl.state && !channelList.$focusItem.data.unlocked ) {
        tools.notifyError(gettext('Channel is censored'));

        return;
    }

    document.body.classList.add('background-off');

    app.route(app.pages.epg, channelList.$focusItem);

    if ( app.ui.preview && app.lastIntent ) {
        app.lastIntent.emit(PLAYER_SET_FULLSCREEN);
    }
}

function goToDetailsPage () {
    var originalFocusedChannelId;

    if ( !channelList.$focusItem ) {
        return;
    }

    if ( !tools.isCensored(channelList.$focusItem.data) || core.accessControl.state || channelList.$focusItem.data.unlocked ) {
        originalFocusedChannelId = channelList.$focusItem.data.id;
        channelList.$focusItem.data.getEpg([], function ( error, data ) {
            if ( error ) { console.log(error); }

            // if user still standing on same channel and waiting for server response
            if ( originalFocusedChannelId === channelList.$focusItem.data.id ) {
                if ( data && data.length ) {
                    document.body.classList.remove('background-off');
                    app.route(app.pages.details, {list: data, channelIndex: channelList.$focusItem.index});
                } else {
                    tools.notifyError(gettext('This channel don\'t have epg'));
                }
            }
        });
    } else {
        tools.notifyError(gettext('Channel is censored'));
    }
}

/**
 * Update footer depending on current channels
 */
function updateFooter () {
    var config = {
        left: {
            code: keys.menu,
            action: showModalActions
        },
        label: {
            code: keys.menu, title: gettext('Hold OK button to open Options menu'), action: showModalActions
        },
        middle: [
            {
                code: keys.f1,
                title: gettext('View'),
                action: togglePageView
            },
            {
                code: keys.f2,
                title: gettext('Sorting'),
                action: function () {
                    page.modalActions.hide();
                    page.modalSort.show();
                }
            }

        ]
    };

    if ( dataBuffer.length ) {
        config.middle = config.middle.concat([
            {
                code: keys.f3,
                title: gettext('Favorite'),
                action: function () {
                    if ( channelList.$focusItem ) {
                        if ( channelList.$focusItem.data.favorite ) {
                            channelList.$focusItem.$favorite.classList.add('hide');
                        } else {
                            channelList.$focusItem.$favorite.classList.remove('hide');
                        }
                        channelList.$focusItem.data.toggleFavorite(function () {
                            app.ui.updateFloatingPanel(channelList.$focusItem.data);
                        });
                    }
                }
            },
            {
                code: keys.f4,
                title: gettext('TV guide'),
                action: goToEpgPage
            }
        ]);
    }

    page.footer.init(config);
}

////////////////////
// BUILD PAGE
app.ui.showPreview(true);
page.footer = new Footer({
    parent: page,
    visible: true,
    data: {
        left: {
            code: keys.menu, action: showModalActions
        },
        middle: [
            {
                code: keys.f1,
                title: gettext('View'),
                action: togglePageView
            },
            {
                code: keys.f2,
                title: gettext('Sorting'),
                action: function () {
                    page.modalSort.show();
                }
            },
            {
                code: keys.f3,
                title: gettext('Favorite'),
                action: function () {
                    if ( channelList.$focusItem ) {
                        if ( channelList.$focusItem.data.favorite ) {
                            channelList.$focusItem.$favorite.classList.add('hide');
                            focusPanel.$favorite.classList.add('hide');
                        } else {
                            channelList.$focusItem.$favorite.classList.remove('hide');
                            focusPanel.$favorite.classList.remove('hide');
                        }
                        channelList.$focusItem.data.toggleFavorite();
                    }
                }
            },
            {
                code: keys.f4,
                title: gettext('TV guide'),
                action: goToEpgPage
            }
        ]
    },
    label: {
        code: keys.menu, title: gettext('Hold OK button to open Options menu'), action: showModalActions
    }
});


function updateListOfPrograms () {
    if ( channelList.$focusItem && channelList.$focusItem.data ) {
        channelList.$focusItem.data.getEpg([], function ( error, data ) {
            if ( error ) { console.log(error); }

            // data = data || [];
            app.ui.updateCurrentChannelEpg(data);
        });
    }

    if ( updateListOfProgramsInterval ) {
        clearInterval(updateListOfProgramsInterval);
    }
    updateListOfProgramsInterval = setInterval(updateListOfPrograms, CURRENT_EPG_UPDATE_DELAY);
}

//updateListOfPrograms();

page.add(channelList = new ExtendedList({
    className: 'mag-component-chanel-list',
    size: app.metrics.channelListSize,
    focusIndex: 0,
    $node: window.channelListNode,
    $body: window.channelListBody,
    data: dataBuffer,
    cycle: true,
    visible: true,
    events: {
        'select:item': function ( event ) {
            var forceFullscreen,
                self = this;


            if ( event.$item && this.$focusItem && app.loaded ) {

                app.ui.updateFloatingPanel(event.$item.data, self.$focusItem.index - self.viewIndex);

                if ( app.ui.preview ) {
                    clearTimeout(playChannelTimeout);
                    playChannelTimeout = setTimeout(function () {
                        if ( tools.isCensored(dataBuffer[self.$focusItem.index]) ) {
                            dataBuffer[self.$focusItem.index].unlocked = false;
                            // channel is under parent password
                            if ( app.lastIntent ) {
                                app.lastIntent.emit(PLAYER_SEND_EXIT);
                            }
                            // we must show some placeholder here
                            app.ui.showCensoredPlaceholder();
                            app.activeChannel = null;
                        } else {
                            dataBuffer[self.$focusItem.index].unlocked = true;
                            app.ui.hideCensoredPlaceholder();

                            if ( !playAtAppStartFlag ) {
                                playAtAppStartFlag = forceFullscreen = true;
                            }

                            if ( core.applicationState.visible && !PLAY_BY_OK ) {
                                playChannel(self.$focusItem.index, {silent: true, forceFullscreen: forceFullscreen});
                            }
                        }
                        app.ui.updateCurrentChannelEpg();
                        updateListOfPrograms();
                    }, 800);
                }

            } else {
                // list is empty so hide focused item, EPG and stop player
                app.ui.updateCurrentChannelEpg();
                if ( app.lastIntent ) {
                    app.lastIntent.emit(PLAYER_SEND_EXIT);
                }
            }
        },
        keydown: function ( event ) {
            List.prototype.defaultEvents.keydown.call(this, event);

            switch ( event.code ) {
                case keys.right:
                    goToDetailsPage();
                    break;
                case keys.left:
                    showLeftMenu();
                    break;
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                    tools.sendOsdInputIntent(String.fromCharCode(event.code), {
                        callback: osdInputCallback
                    });
                    break;
                case keys.back:
                    showExit();
                    break;
                    // reflect channel next/prev to up/down keys
                case keys.channelNext:
                    this.emit('keydown', {code: keys.down});
                    break;
                case keys.channelPrev:
                    this.emit('keydown', {code: keys.up});
                    break;
            }
        },
        'click:item': handleChannelClick,
        'move:view': updateCurrentChannelsEpg
    },
    render: require('../modules/channels.list.item.render')
}));
page.channelList = channelList;


// modal message: all actions
page.modalActionsScroll = new ScrollBar({realSize: 6, viewSize: 7});
page.modalActions = new ModalMessage({
    visible: false,
    className: 'width2x',
    title: gettext('Menu'),
    events: {
        show: function () {
            page.footer.hide();
            this.focus();
        },
        hide: function () {
            page.footer.show();
            channelList.focus();
        }
    },
    children: [
        page.modalActionsList = new LayoutList({
            cycle: true,
            focusIndex: 0,
            size: 4,
            scroll: page.modalActionsScroll,
            data: []
        }),
        page.modalActionsScroll
    ]
});
page.add(page.modalActions);

page.leftMenu = new ModalMessage({
    visible: false,
    className: 'left-side',
    title: gettext('Menu'),
    events: {
        show: () => {
            page.footer.hide();
            page.leftMenu.focus();
        },
        hide: () => {
            page.footer.show();
            channelList.focus();
        }
    },
    children: [
        page.leftMenuList = new LayoutList({
            cycle: true,
            focusIndex: 0,
            data: [],
            events: {
                keydown: function ( event ) {
                    LayoutList.prototype.defaultEvents.keydown.call(this, event);
                    if ( event.code === keys.right ) {
                        page.leftMenu.hide();
                    }
                }
            }
        })
    ]
});


page.leftMenu.$closeIcon = document.createElement('div');
page.leftMenu.$closeIcon.className = icons.CANCEL + ' closeIcon';
page.leftMenu.$body.parentElement.appendChild(page.leftMenu.$closeIcon);

page.add(page.leftMenu);

// modal message: sort
page.modalSort = new ModalMessage({
    visible: false,
    title: gettext('sort'),
    events: {
        show: function () {
            page.footer.hide();
            this.focus();
        },
        hide: function () {
            page.footer.show();
            channelList.focus();
        }
    },
    children: [
        new RadioList({
            cycle: true,
            focusIndex: 0,
            propagate: true,
            size: 2,
            data: [
                {state: false, title: gettext('By name'), value: 0},
                {state: true, title: gettext('By number'), value: 1}
            ],
            events: {
                'click:item': function ( event ) {
                    console.log('set sort flag to: ' + (event.$item.data.value ? 'by number' : 'by name'));
                    tvConfig.byName = !event.$item.data.value;
                    page.modalSort.hide();
                    getChannels();
                }
            }
        })
    ]
});
page.add(page.modalSort);

// modal message: filter
page.modalFilter = new ModalMessage({
    visible: false,
    title: gettext('Categories'),
    events: {
        show: function () {
            page.footer.hide();
            this.focus();
        },
        hide: function () {
            page.footer.show();
            channelList.focus();
        }
    },
    children: [
        new LayoutList({
            cycle: true,
            data: [],
            className: 'padded',
            events: {
                'click:item': function ( event ) {
                    console.log('set filter flag to: ' + JSON.stringify(event.$item.data.value));
                    tvConfig.genre = event.$item.data.value.id;
                    tvConfig.genreName = event.$item.data.value.name;
                    page.modalFilter.hide();
                    getChannels();
                }
            }
        })
    ]
});
page.add(page.modalFilter);

// get categories from plugin and create filter list in modal
app.tvBack.getCategories(function ( error, data ) {
    var categories = [
        {
            items: [{value: gettext('All categories'), className: 'title'}],
            value: {id: false, name: gettext('All categories')}
        }
    ];

    if ( !error ) {
        genresList = data;
        data.forEach(function ( genre ) {
            categories.push({
                items: [{value: genre.name, className: 'title'}],
                value: genre
            });
        });
    }
    page.modalFilter.children[0].init({
        data: categories,
        focusIndex: 0
    });
});

page.addListener('show', function ( event ) {
    if ( app.ui.preview ) {
        document.body.classList.add('background-off');
    } else {
        document.body.classList.remove('background-off');
    }
    channelList.focus();

    if ( event && event.data ) {
        channelList.focusIndex(event.data.index);
    }

    if ( core.applicationState.visible && !app.lastIntent && currentChannelIndex ) {
        playChannel(currentChannelIndex);
    }
});

/**
 * Show modal actions depends on current content
 */
function showModalActions () {
    /*eslint max-lines-per-function:0*/
    var menuItems,
        currentChannel;

    menuItems = [
        {
            items: [
                {className: LIST_ICONS.view},
                {value: gettext('View')}
            ],
            click: function () {
                page.modalActions.hide();
                togglePageView();
            }
        }
    ];

    if ( channelList.$focusItem && channelList.$focusItem.data ) {
        currentChannel = channelList.$focusItem.data;

        // add favorite button
        menuItems.splice(2, 0, {
            items: [
                {className: currentChannel.favorite ? LIST_ICONS.favoriteActive : LIST_ICONS.favorite},
                {value: currentChannel.favorite ? gettext('Remove from Favorites') : gettext('Add to favorite')}
            ],
            click: function () {
                if ( channelList.$focusItem ) {
                    if ( channelList.$focusItem.data.favorite ) {
                        channelList.$focusItem.$favorite.classList.add('hide');
                    } else {
                        channelList.$focusItem.$favorite.classList.remove('hide');
                    }
                    channelList.$focusItem.data.toggleFavorite(function () {
                        app.ui.updateFloatingPanel(channelList.$focusItem.data);
                    });
                }
                page.modalActions.hide();
            }
        });

        menuItems.splice(3, 0, {
            items: [
                {className: LIST_ICONS.tvGuide},
                {value: gettext('TV guide')}
            ],
            click: function () {
                page.modalActions.hide();
                goToEpgPage();
            }
        });

        if ( currentChannel.pvr || currentChannel.local_pvr ) {
            menuItems.splice(4, 0, {
                items: [
                    {className: LIST_ICONS.record},
                    {value: gettext('Record')}
                ],
                click: function () {
                    page.modalActions.hide();
                    tools.sendRecordIntent(currentChannel);
                }
            });
        }
    }

    page.modalActionsList.init({
        data: menuItems,
        size: menuItems.length,
        focusIndex: 0
    });

    setTimeout(function () {
        page.modalActions.show();
    }, 10);
}

function showLeftMenu () {
    var menuItems = [
        {
            items: [
                {className: icons.SEARCH + (tvConfig.search ? ' active' : '')},
                {value: tvConfig.search || gettext('Search')}
            ],
            click: function () {
                page.leftMenu.hide();

                tools.sendSearchIntent(tvConfig.search || '', function ( value ) {
                    tvConfig.search = value;
                    getChannels();
                });
            }
        },
        {
            items: [
                {className: (tvConfig.favorite ? icons.FAVORITE_ACTIVE + ' active' : icons.FAVORITE)},
                {value: gettext('Favorite list')}
            ],
            click: function () {
                tvConfig.favorite = !tvConfig.favorite;
                console.log('set favorite list to ' + tvConfig.favorite);
                page.leftMenu.hide();
                getChannels();
            }
        },
        {
            items: [
                {className: icons.CATEGORIES + (tvConfig.genre ? ' active' : '')},
                {value: tvConfig.genreName}
            ],
            click: function () {
                page.leftMenu.hide();
                page.modalFilter.show();
            },
            className: 'theme-item-more'
        },
        {
            items: [
                {className: icons.SORT_AZ},
                {value: tvConfig.byName ? gettext('By name') : gettext('By number')}
            ],
            click: function () {
                page.leftMenu.hide();
                page.modalSort.show();
            },
            className: 'theme-item-more'
        },
        {
            items: [
                {className: 'theme-icon theme-icon-reset-filters'},
                {value: gettext('Reset filters')}
            ],
            click: function () {
                page.leftMenu.hide();
                setTimeout(function () {
                    page.modalFilter.children[0].init({
                        data: page.modalFilter.children[0].data,
                        focusIndex: 0
                    });
                }, 10);
                tvConfig.favorite = false;
                tvConfig.genre = false;
                tvConfig.genreName = gettext('All categories');
                tvConfig.search = false;

                getChannels();
            }
        }
    ];

    page.leftMenuList.setData({
        data: menuItems,
        focusIndex: 0
    });

    setTimeout(function () {
        page.leftMenu.show();
    });

}

function getChannels ( config, callback ) {
    var index,
        indexToFocus = 0;

    config = config || {};
    app.ui.hideCensoredPlaceholder();
    app.tvBack.updateChannelsList(function () {
        dataBuffer = [];
        app.tvBack.getChannels(tvConfig, function ( error, channels ) {
            if ( error ) {
                console.log('app.tvBack.getChannels error');
            }

            setTimeout(function () {
                app.pages.epg.setChannels(channels);
            });

            dataBuffer = channels;
            page.dataBuffer = dataBuffer;

            if ( channels.length ) {
                app.ui.showFloatingPanel();
            } else {
                app.ui.hideFloatingPanel();
            }

            if ( config.focusId !== undefined ) {
                for ( index = 0; index < dataBuffer.length; index++ ) {
                    if ( dataBuffer[index].id === Number(config.focusId) ) {
                        indexToFocus = index;
                    }
                }
            } else if ( config.focusIndex !== undefined ) {
                indexToFocus = config.focusIndex;
            } else if ( channelList.$focusItem && channelList.$focusItem.index < dataBuffer.length ) {
                indexToFocus = channelList.$focusItem.index;
            } else {
                indexToFocus = 0;
            }

            currentChannelIndex = indexToFocus;

            app.ui.updateChannelsListTitle(tvConfig, genresList);
            app.ui.updateChannelsListCount(dataBuffer.length);

            updateFooter();


            channelList.hide();
            channelList.init({
                data: dataBuffer,
                focusIndex: indexToFocus,
                cycle: true
            });

            // prevent graphic bug on 322
            setTimeout(function () {
                channelList.show();

                if ( callback ) {
                    callback();
                }
            }, 5);
        });
    });
}

/**
 * App start
 */
app.tvBack.getLastChannelId(function ( error, id ) {
    function doneHandler () {
        if ( app.tvBack.startBackgroundCheck ) {
            app.tvBack.startBackgroundCheck();
        }

        app.loaded = true;
        app.emit('ready');

        setTimeout(function () {
            app.ready();
        }, 50);
    }

    getChannels({
        focusIndex: 0,
        focusId: (!error && id) ? id : undefined
    }, function () {
        if ( app.ui.canvasLoaded ) {
            doneHandler();
        } else {
            app.once('background:load', doneHandler);
        }
        updateListOfPrograms();
    });
});


page.addEpgListeners = function ( epgPage ) {

    epgPage.addListener('back', function ( item ) {
        app.route(app.pages.main, item);
        if ( app.ui.preview && app.lastIntent ) {
            app.lastIntent.emit(PLAYER_SET_VIEWPORT, app.metrics.canvasPosition);
        } else if ( !app.ui.preview && app.lastIntent ) {
            app.lastIntent.emit(PLAYER_SEND_EXIT);
        }
    });

    epgPage.addListener('channel:click', function ( event ) {
        console.log(event, 'channel:click');
        if ( dataBuffer[event.channelIndex] && tools.isCensored(dataBuffer[event.channelIndex]) ) {
            core.accessControl.request(function ( error ) {
                if ( !error ) {
                    playChannel(event.channelIndex);
                    app.lastIntent.emit(PLAYER_SET_FULLSCREEN);
                }
            });
        } else if ( dataBuffer[event.channelIndex] ) {
            playChannel(event.channelIndex);
            app.lastIntent.emit(PLAYER_SET_FULLSCREEN);
        }
    });

    epgPage.addListener('epg:click', function ( event ) {
        console.log(event, 'epg:click');
        // sendPlayEpgIntent()
    });

};


app.addListener(RIGHT_ARROW_CLICK, goToDetailsPage);
app.addListener(LEFT_ARROW_CLICK, showLeftMenu);


/**
 * Update render view after channels events from provider
 */
function updateRenderOnProviderEvent () {
    getChannels();
}

/**
 * Callback when some channels was deleted
 *
 * @param {Object} event from provider
 */
function deleteChannelsHandler ( event ) {
    core.notify({
        title: format(window.ngettext('{0} channel was deleted', '{0} channels were deleted', event.data.length), event.data.length),
        icon: 'alert',
        type: 'warning',
        timeout: CHANNELS_UPDATE_NOTIFY_TIMEOUT
    });
    updateRenderOnProviderEvent();
}

/**
 * Callback when some channels was added
 *
 * @param {Object} event from provider
 */
function addChannelsHandler ( event ) {
    if (event.data.length > 1 ) {
        core.notify({
            title: format(gettext('{0} channels were added'), event.data.length),
            icon: 'info',
            type: 'success',
            timeout: CHANNELS_UPDATE_NOTIFY_TIMEOUT
        });
    } else if ( event.data.length === 1 ) {
        core.notify({
            title:  format(gettext('Channel {0} was added'), event.data[0].name),
            icon: 'info',
            type: 'success',
            timeout: CHANNELS_UPDATE_NOTIFY_TIMEOUT
        });
    }

    updateRenderOnProviderEvent();
}

/**
 * Callback when some channels was modified
 */
function modifyChannelsHandler () {
    core.notify({
        title: gettext('Channels were updated'),
        icon: 'info',
        type: 'success',
        timeout: CHANNELS_UPDATE_NOTIFY_TIMEOUT
    });

    updateRenderOnProviderEvent();
}

/**
 * Callback when backend send message to full update channels list
 */
function fullUpdateChannelsHandler () {

    if ( core.applicationState.visible ) {
        core.notify({
            title: gettext('Channels were updated'),
            icon: 'info',
            type: 'success',
            timeout: 2500
        });
    }

    updateRenderOnProviderEvent();
}

app.tvBack.addListener('channels:delete', deleteChannelsHandler);
app.tvBack.addListener('channels:add', addChannelsHandler);
app.tvBack.addListener('channels:modified', modifyChannelsHandler);
app.tvBack.addListener('update', fullUpdateChannelsHandler);


// show app event handler
core.addListener(CORE_EVENT_SHOW, function ( event ) {
    var forceFullscreen;

    console.log('CORE_EVENT_SHOW ' + event.source, 'app show event');
    console.log(event, 'app show event');

    if ( osdTvIntent ) {
        osdTvIntent.close();
    }

    // app is shown by intent from player
    if (
        event.source === core.SOURCES.INTENT
        && event.data
        && event.data.intent
        && event.data.intent.action === 'play'
        // player send this flag if we click list button
        && event.data.config.reasonToggleView
    ) {
        if ( app.ui.preview ) {
            app.lastIntent.emit(PLAYER_SET_VIEWPORT, app.metrics.canvasPosition);
        } else {
            app.lastIntent.emit(PLAYER_SEND_EXIT);
        }
        channelList.focusIndex(currentChannelIndex);
        if ( osdTvIntent ) {
            osdTvIntent.close();
        }
    } else if (
        event.source === core.SOURCES.INTENT
        && event.data
        && event.data.intent
        && event.data.intent.action === 'play'
        // player send this flag is we press pip button
        && event.data.config.reasonPip
    ) {
        // we should do nothing cause player go to pip
        // here will be some handlers in future if we need
        console.log('playback go to pip');
        if ( osdTvIntent ) {
            osdTvIntent.close();
        }
    } else if (
        event.source !== core.SOURCES.SYSTEM &&
        app.ui.preview && channelList.$focusItem &&
        !tools.isCensored(channelList.$focusItem.data)
        && app.loaded
    ) {
        if ( !playAtAppStartFlag ) {
            console.log('forceFullscreen--->');
            playAtAppStartFlag = forceFullscreen = true;
        }

        // we are restored
        playChannel(currentChannelIndex, {forceFullscreen: forceFullscreen});
    } else if (
        event.source === core.SOURCES.SYSTEM &&
        event.data &&
        event.data.intent &&
        event.data.intent.action === 'record'
    ) {
        // we are shown after record manager closed
        if ( app.ui.preview ) {
            playChannel(currentChannelIndex, {silent: true});
        }
    }
});

// hide app event handler
core.addListener(CORE_EVENT_HIDE, function ( event ) {
    console.log('CORE_EVENT_HIDE ' + event.source, 'app hide');
    if ( event.source === core.SOURCES.INTENT && event.data && event.data.intent && event.data.intent.action === 'play' ) {
        //
        if ( app.ui.preview ) {
            // maybe do something with focus
        } else {
            // app.lastIntent.emit('exit');
        }
    } else {
        app.lastIntent.emit(PLAYER_SEND_EXIT);
        ctx = null;
    }
});

core.addListener(CORE_EVENT_EXIT, function () {
    if ( app.lastIntent ) {
        app.lastIntent.emit(PLAYER_SEND_EXIT);
    }

    if ( osdTvIntent ) {
        osdTvIntent.close();
    }

    app.tvBack.removeListener('channels:delete', deleteChannelsHandler);
    app.tvBack.removeListener('channels:add', addChannelsHandler);
    app.tvBack.removeListener('channels:modified', modifyChannelsHandler);
    app.tvBack.removeListener('update', fullUpdateChannelsHandler);
    app.tvBack.stopBackgroundCheck();

    if ( app.tvBack.destroy ) {
        app.tvBack.destroy();
    }


});

core.addListener(CORE_EVENT_PLAY_CHANNEL, function ( data ) {
    var index,
        indexToPlay;

    function findAndPlay ( number ) {
        for ( index = 0; index < dataBuffer.length; index++ ) {
            if ( dataBuffer[index].number === number ) {
                indexToPlay = index;
                break;
            }
        }

        if ( indexToPlay !== undefined ) {
            // if channel to play is not censored we should play
            if (
                !dataBuffer[indexToPlay].censored
                && dataBuffer[indexToPlay].genre
                && !dataBuffer[indexToPlay].censored
            ) {
                channelList.focusIndex(indexToPlay);
                playChannel(indexToPlay, {fullscreen: true});
            }
        }
    }

    function processAndPlay ( number ) {
        if ( app.loaded ) {
            findAndPlay(number);
        } else {
            app.once('ready', function () {
                console.log('APP READY');
                findAndPlay(number);
            });
        }
    }

    // if we have some filters we should reset it first
    if (
        tvConfig.favorite
        || tvConfig.byName
        || tvConfig.genre
        || tvConfig.search
    ) {
        tvConfig.favorite = false;
        tvConfig.genre = false;
        tvConfig.genreName = gettext('All categories');
        tvConfig.search = false;
        getChannels(null, function () {
            processAndPlay(data.number);
        });
    } else {
        processAndPlay(data.number);
    }
});

// public
module.exports = page;
